<template>
		<div class="success-container">
			<div class="success-png"><div class="success-v"></div></div>
			<div class="success-text">{{content}}</div>
		</div>
</template>
<script>
  export default {
    props:{
      content:{
        type:String,
        default: '保存成功'
      }
    }
  }
</script>
<style lang="less" scoped>
		.success-container {
			.success-png {
				margin: 0 auto;
				width: 60px;
				height: 60px;
				background: #D9E9FF;
				border-radius: 30px 30px;
				.success-v {
					width: 30px;
					height: 15px;
					border: 3px solid #4C7EC5;
					border-right: none;
					border-top: none;
					transform: rotate(-45deg) translateX(-2px) translateY(23px);
				}
			}
			.success-text {
				text-align: center;
				margin-top: 20px;
				margin-bottom: 20px;
				font-size: 21px;
				font-weight: 600;
				line-height: 30px;
			}
		}
</style>